<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingAcademySalesDropDownFilters"
  >
    <section
      v-if="showLoadingState < 4"
      key="loadingState"
      class="m-dropdown-section"
    >
    <ul class="m-dropdown-list">
      <li>
        <a
          href="#"
          @click.prevent=""
        >
          <AtomLoadingSecondary/>
        </a>
      </li>
    </ul>
    </section>
    <form
      v-else
      key="billingAcademySalesDropDownFilters"
      autocomplete="off"
      name="AcademySalesDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.pais"
                :elements="paisesSelect"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.divisa.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(divisa, index) in divisas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.divisa"
                    inputStyle="billing"
                    name="moneda"
                    :text="divisa.nombre"
                    :value="divisa.id_divisa"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.medioPago.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(pasarela, index) in pasarelasPago"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.pasarela_pago"
                    inputStyle="billing"
                    name="medio"
                    :text="pasarela.nombre"
                    :value="pasarela.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.fechaDesde.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingAcademySalesDropDownFilters.input.fechaDesde.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.fechaHasta.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingAcademySalesDropDownFilters.input.fechaHasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.type_product.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.type_product"
                :elements="tipoProducto"
                key-field="id"
                name="name"
                reference="name"
                text-field="name"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.productos.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(producto, index) in productosFiltradosByTipo"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.producto"
                    inputStyle="billing"
                    name="productos"
                    :text="producto.nombre"
                    :value="producto.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingAcademySalesDropDownFilters.input.descuento.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.cupon"
                class="a-input-primary"
                name="descuento"
                :placeholder="$t('mEditionBillingAcademySalesDropDownFilters.input.descuento.placeholder')"
                type="text"
              >
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionBillingAcademySalesDropDownFilters.buttonSecondary.restartText') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionBillingAcademySalesDropDownFilters.buttonPrimary') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademySalesDropDownFilters',

  props: {
    academiaIdSeted: String,
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      divisas: [],
      estadosVentas: [],

      filter: {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        type_sales: '',
        type_product: ''
      },

      pasarelasPago: [],
      paises: [],
      productos: [],
      radioButtonPrimary: {
        typeSales: {
          labelClass: 'a-radiobutton-billing-primary font-size-small',
          name: 'type-sale'
        }
      },
      showLoadingState: 0
    }
  },

  computed: {
    paisesSelect () {
      let paises = [...this.paises]
      paises.unshift({
        id_pais: '',
        nombre: this.$t('mEditionBillingAcademySalesDropDownFilters.input.pais.firstOption')
      })
      return paises
    },

    tipoProducto () {
      let tipos = [
        {
          id: 0,
          name: this.$t('mEditionBillingAcademySalesDropDownFilters.input.type_product.second')
        },
        {
          id: 1,
          name: this.$t('mEditionBillingAcademySalesDropDownFilters.input.type_product.third')
        }
      ]
      tipos.unshift({
        id: '',
        name: this.$t('mEditionBillingAcademySalesDropDownFilters.input.type_product.first')
      })
      return tipos
    },

    productosFiltradosByTipo () {
      if (this.filter.type_product === '') {
        return this.productos;
      }
      let tipoSeleccionado = Number(this.filter.type_product);

      if (tipoSeleccionado === 1) {
        return this.productos.filter(producto => producto.producto_vidroop);
      } else if (tipoSeleccionado === 0) {
        return this.productos.filter(producto => !producto.producto_vidroop);
      } else {
        return this.productos;
      }
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    'filter.type_sales' () {
      if (this.filter.type_sales) {
        this.filter.estado = []
      }
    },

    academiaIdSeted: {
      deep: true,

      handler () {
        this.readProductos()
      },

      immediate: true
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.buscar = this.filterSeted.buscar
        this.filter.cupon = this.filterSeted.cupon
        this.filter.divisa = [...this.filterSeted.divisa]
        this.filter.estado = [...this.filterSeted.estado]
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.type_sales = this.filterSeted.type_sales
        this.filter.type_product = this.filterSeted.type_product
        this.filter.pais = this.filterSeted.pais
        this.filter.pasarela_pago = [...this.filterSeted.pasarela_pago]
        this.filter.producto = [...this.filterSeted.producto]

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    this.estadosVentas = [...this.$filters.parameters.salesStates].filter(s => s.id !== 9)
    this.estadosVentas.shift()
    this.readDivisas()
    this.readPasarelasPagoActivas()
    this.readParametroPaises()
    this.readProductos()
  },

  methods: {
    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readPasarelasPagoActivas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelasPago = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readProductos () {
      this.$services.read('producto', 'readProductos', {}, [this.academiaIdSeted], { limite: 1000 })
        .then(response => {
          this.productos = response.data.productos
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingAcademySalesDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter, this.academia_url)
    }
  }
}
</script>
